import React, { PureComponent } from 'react';
import cn from 'classnames';
import { string, func, object, oneOfType } from 'prop-types';

class CardBody extends PureComponent {
  static propTypes = {
    tag: oneOfType([func, string]),
    className: string,
    innerRef: oneOfType([object, func, string]),
  };

  static defaultProps = {
    tag: 'div',
  };

  render() {
    const { className, tag: Tag, innerRef, ...attributes } = this.props;
    return <Tag ref={innerRef} className={cn(className, 'card-body')} {...attributes} />;
  }
}

export default CardBody;
